var exports = {
  "k": "xa15a2ab7--ebd1bf--container",
};

module.exports = exports;
